import React from 'react'

import Header from '../../common/components/Header'
import IncidentList from './IncidentList'

const IncidentTogglePanel = () => {
  return (
    <>
      <Header>Click to Toggle Events</Header>
      <IncidentList />
    </>
  )
}

export default IncidentTogglePanel
